const calculateRHSAmt = (rhsMaxCts, rhsRate) => {
    return rhsMaxCts * rhsRate;
};

const calculateTotals = (stoneDetails, detail) => {
    
    let totalLHSAmt = 0;
    let totalLSHRate = 0;
    let totalRHSRate = 0;
    let totalRHSAmt = 0;
    let margin = 0;
    let marginPercentage = 0;
    const totalRHSAmtArray = [];

    stoneDetails.forEach((stone) => {
        totalLHSAmt += stone.lhsAmt;
        totalLSHRate += stone.lhsRate;
        totalRHSRate += stone.rhsRate;
        const calculatedRHSAmt = calculateRHSAmt(stone.rhsMaxCts, stone.rhsRate);
        totalRHSAmt += calculatedRHSAmt;
        totalRHSAmtArray.push(totalRHSAmt);
        stone.rhsAmt = calculatedRHSAmt;
        margin = (totalRHSAmt - totalLHSAmt) / totalRHSAmt;
        marginPercentage = margin * 100;
    });


    return {
        totalLHSAmt,
        totalLSHRate,
        totalRHSRate,
        totalRHSAmt,
        totalRHSAmtArray,
        margin,
        marginPercentage,
    };
};


const uniqueIdGen = (stoneDetail) => {
    const existingId = stoneDetail._id;
    const idLength = existingId.length;
  
    // Generate a new random number to replace the last 3-4 digits
    const randomPart = Math.floor(Math.random() * 10000).toString().padStart(4, '0'); // Ensure it's 4 digits
  
    // Create the new ID by replacing the last 4 characters with the random part
    const newId = existingId.slice(0, idLength - 4) + randomPart;
  
    return newId;
  };

  
export {calculateTotals, uniqueIdGen}


